export default __webpack_public_path__ + "static/media/google-play.8a2e77bf.svg";